module.exports = __webpack_public_path__ + "img/devoluciones.6326241c.png";